/**
 * Copyright © 2024-2026 Entangled Harmony Labs, LLC
 * All Rights Reserved. Proprietary and Confidential.
 */

import { useAuth } from '../../hooks/useAuth';

/**
 * Badge showing user's subscription tier
 */
export const SubscriptionBadge = () => {
  const { subscriptionTier, userProfile } = useAuth();

  if (!userProfile) return null;

  const getBadgeColor = () => {
    switch (subscriptionTier) {
      case 'pro':
        return 'bg-indigo-100 text-indigo-800';
      case 'premium':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getBadgeText = () => {
    switch (subscriptionTier) {
      case 'pro':
        return 'Pro';
      case 'premium':
        return 'Premium';
      default:
        return 'Free';
    }
  };

  return (
    <span className={`hidden md:inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getBadgeColor()}`}>
      {getBadgeText()}
    </span>
  );
};
